<app-layout title="Subir mi Informe">
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-3">
    <ul class="nav nav-tabs mb-0">
      <li class="nav-item">
        <a class="nav-link" 
           [class.active]="activeTab === 'tab1'"
           (click)="changeTab('tab1')">Inicio</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" 
           [class.active]="activeTab === 'tab2'"
           (click)="changeTab('tab2')">Resumen de Informe</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" 
           [class.active]="activeTab === 'tab3'"
           (click)="changeTab('tab3')">Agregar Conceptos</a>
      </li>
      <li class="nav-item" *ngIf="ecclesiasticDataTabVisible">
        <a class="nav-link"
           [class.active]="activeTab === 'tab4'"
           (click)="changeTab('tab4')">Datos Eclesiasticos</a>
      </li>
    </ul>
  </div>

  <div class="tab-content mt-3">
    <div class="tab-pane fade" [class.show]="activeTab === 'tab1'" [class.active]="activeTab === 'tab1'" id="tab1">
      <app-report-tutorial></app-report-tutorial>
    </div>
    <div class="tab-pane fade" [class.show]="activeTab === 'tab2'" [class.active]="activeTab === 'tab2'" id="tab2">
      <app-view-concepts></app-view-concepts>
    </div>
    <div class="tab-pane fade" [class.show]="activeTab === 'tab3'" [class.active]="activeTab === 'tab3'" id="tab3">
      <app-add-edit-concept-response></app-add-edit-concept-response>
    </div>
    <div class="tab-pane fade" *ngIf="ecclesiasticDataTabVisible" [class.show]="activeTab === 'tab4'" [class.active]="activeTab === 'tab4'" id="tab4">
      <app-district-data></app-district-data>
    </div>
  </div>
  </app-layout>
